import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-folder-outline",
  "use": "sd-folder-outline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sd-folder-outline\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 1a2 2 0 00-2 2v18c0 1 1 2 2 2h20c1 0 2-1 2-2V5a2 2 0 00-2-2h-9l-1.707-1.707A1 1 0 0010.586 1H2zm20 7H2v13h20V8z\" /><path d=\"M6 11h12v1H6v-1zm0 3h12v1H6v-1zm12 3H6v1h12v-1z\" opacity=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol